import type { CommentVisibility } from '@atlassian/jira-issue-view-common-types/src/comment-type';

export const areCommentVisibilitiesEqual = (item: CommentVisibility, item2: CommentVisibility) =>
	item.value === item2.value && item.type === item2.type;
